import {action, observable, computed} from 'mobx';
import {getGameList, getHistoryList, uploadBegin, uploadEnd, clearHistory, deleteGame} from '@/services/fileOpear'
import Encryption from "@/utils/Encryption";
import {Modal, message} from 'antd'
import report from '@/utils/log'

const COS = require('cos-js-sdk-v5')

/**
 * 文件状态
 */
export enum fileStatus {
  normal = 1, // 正常
  delete = 2 // 已删除
}

/**
 * 文件上传类型
 */
export interface fileTypes {
  id: number;
  userId: number;
  roomId: number;
  outLink: string;
  innerLink: string;
  bundleId: string;
  fileName: string;
  appName: string;
  versionName: string;
  appSize: number;
  md5: string;
  remarks: string;
  status: fileStatus;
  createTime: string;
  updateTime: string;
}

/**
 * 正在上传文件
 */
export interface FileUploadingType {
  id: number;
  fileName: string;
  percent: number
}

export interface FileUploadingTypes{
  [propName:number]: FileUploadingType[]
}

/**
 * 文件上传历史记录类型
 */
export interface fileHistoryTypes {
  id: number;
  userId: number;
  roomId: number;
  outLink: string;
  innerLink: string;
  fileName: string;
  appSize: number;
  md5: string;
  status: fileStatus;
  createTime: string;
  updateTime: string;
}

// 导航选择下标
export type SelectIndexType = 1 | 2 | 3

export default class UploadStore {

  @observable showModal: boolean = false // 弹框展示
  @observable selectIndex: SelectIndexType = 1 // 选择的导航的位置

  @observable used_space = 0 // 已用
  @observable all_space = 0 // 总共空间

  @observable fileList: fileTypes [] = [] // 全部文件
  @observable fileUploading: FileUploadingTypes = {} // 正在上传文件
  @observable fileHistoryList: fileHistoryTypes [] = [] // 上传记录

  // // 显示数据
  // @computed get getDataSource(): any[] {
  //   let roomId: number = JSON.parse(localStorage.getItem('activeRoom') as string).id
  //   return (this.selectIndex === 1 && this.fileList) || (this.selectIndex === 2 && (this.fileUploading[roomId] || [])) || (this.selectIndex === 3 && this.fileHistoryList) || []
  // }
  @computed get getFileUploading() :FileUploadingType[]{
    let roomId: number = JSON.parse(localStorage.getItem('activeRoom') as string).id
    return this.fileUploading[roomId] || []
  }
  @action.bound init() {
    this.selectIndex = 1
    this.used_space = 0
    this.all_space = 0
    this.fileList = []
    this.fileHistoryList = []
    this.getFileList()
  }

  // 获取全部文件
  @action.bound
  async getFileList() {
    let params = {
      roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id
    }
    const [error, result] = await getGameList(params)
    console.log(error, result)
    if (error) {
      // 获取上传文件列表失败 事件上报
      report({
        eventId: 'E0511',
        pageId: 'P05',
        ext: '',
      })
      return;
    }
    // 全部文件加载完成事件上报
    report({
      eventId: 'E0500',
      pageId: 'P05',
      ext: '',
    })

    this.fileList = result.game_list
    this.used_space = result.used_space
    this.all_space = result.all_space
  }

  // 获取上传记录
  @action.bound
  async getFileHistoryList() {

    let params = {
      roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id
    }
    const [error, result] = await getHistoryList(params)
    if (error) {
      // 获取上传文件列表失败  事件上报
      report({
        eventId: 'E0513',
        pageId: 'P05',
        ext: '',
      })
      return;
    }
    this.fileHistoryList = result.attach_list
  }

  @action.bound changeModalShow(bool: boolean) {
    this.showModal = bool
  }

  // 修改导航
  @action.bound
  async changeSelectIndex(index: SelectIndexType) {
    if (this.selectIndex === index) return;
    this.selectIndex = index
    index === 1 && this.getFileList()
    if(index === 3) {
      report({
        eventId: 'E0501',
        pageId: 'P05',
        ext: '',
      })
      this.getFileHistoryList();
    }
    // 点击正在上传  事件上报
    index === 2 &&  report({
      eventId: 'E0515',
      pageId: 'P05',
      ext: '',
    })

  }

  // 选择文件
  @action.bound
  async getFile(e: any) {
    let upload: any = document.getElementById('upload')
    let file = upload.files[0]
    console.log(file)
    e.target.value = null
    if (file) {
      let name = file.name;
      let nameArray = name.split('.')
      if (nameArray[nameArray.length - 1] !== 'apk') {
        console.log('请上传apk格式文件')
        e.target.value = null
        return
      }
    }
    // 选择文件完毕，开始上传 事件上报
    report({
      eventId: 'E0504',
      pageId: 'P05',
      ext: '',
    })

    let {id, sign} = await this.uploadBegin(file as any)

    let newFile = {
      id: id,
      fileName: file.name,
      percent: 0
    }
    console.log(newFile)

    let roomId:number = JSON.parse(localStorage.getItem('activeRoom') as string).id
    let fileUploading = (this.fileUploading[roomId] || []).slice()
    this.fileUploading[roomId] = [...fileUploading, newFile]
    const len = this.fileUploading[roomId].length - 1
    this.uploading(file, id, sign, len)
  }

  //开始上传
  @action.bound
  async uploadBegin(file: any) {
    let params = {
      roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id,
      appSize: file.size,
      fileName: decodeURIComponent(file.name)
    }
    const [error, result] = await uploadBegin(params)
    if (error) {
      // 获取腾讯cos签名失败 事件上报
      report({
        eventId: 'E0507',
        pageId: 'P05',
        ext: '',
      })
      return;
    }
    return result
  }

  //上传文件
  @action.bound
  async uploading(file: any, id: number, sign: string, index: number) {
    let {secretKey, secretId, bucket, region} = JSON.parse(Encryption.decayFun(sign, 'NgAbCJJGfUlQ6653'))
    console.log(secretKey, secretId, bucket, region)
    let cos = new COS({
      getAuthorization: function (options: any, callback: any) {
        var authorization = COS.getAuthorization({
          SecretId: secretId,
          SecretKey: secretKey,
          Method: options.Method,
          Key: options.Key,
          Query: options.Query,
          Headers: options.Headers,
          Expires: 60,
        });
        callback(authorization)
      },
    });

    cos.sliceUploadFile({
      Bucket: bucket,
      Region: region,
      Key: decodeURIComponent(file.name),
      Body: file,
      onHashProgress: (progressData: any) => {
        console.log('校验中', JSON.stringify(progressData));
      },
      onProgress: (progressData: any) => {
        console.log('onProgress')
        console.log(progressData)
        let roomId:number = JSON.parse(localStorage.getItem('activeRoom') as string).id
        let fileUploadingRoomId = (this.fileUploading[roomId] || []).slice()
        let percent = Math.floor(progressData.percent * 100)
        let file = {
          ...fileUploadingRoomId[index],
          percent: percent
        }
        fileUploadingRoomId.splice(index, 1, file)
        this.fileUploading = {
          ...JSON.parse(JSON.stringify(this.fileUploading)),
          [roomId]: fileUploadingRoomId
        }
      },
    }, (err: any, data: any) => {
      if (data) {
        console.log('上传成功')
        console.log(data)

        this.uploadEnd({
          attachId: id,
          outLink: decodeURIComponent(data.Location),
          md5: data.ETag,
          fileName: decodeURIComponent(file.name)
        })

      } else {
        console.log('上传失败')
        console.log(err)
        //  cos上传失败 （包含签名失败） 事件上报
        report({
          eventId: 'E0509',
          pageId: 'P05',
          ext: '',
        })
        // 文件上传失败  事件上报
        report({
          eventId: 'E0506',
          pageId: 'P05',
          ext: '',
        })
      }
    });
  }

  // 上传完成
  @action.bound
  async uploadEnd(data: object) {
    //  文件上传cdn成功 事件上报
    report({
      eventId: 'E0505',
      pageId: 'P05',
      ext: '',
    })

    const [error] = await uploadEnd(data)
    if(error) {
      //  上传完成通知失败 事件上报
      report({
        eventId: 'E0510',
        pageId: 'P05',
        ext: '',
      })
    }
  }

  // 清楚记录
  @action.bound
  async clearHistory() {

    let params = {
      roodId: JSON.parse(localStorage.getItem('activeRoom') as string).id
    }
    const [error] = await clearHistory(params)
    if (error) {
      // 点击清楚记录失败 事件上报
      report({
        eventId: 'E0514',
        pageId: 'P05',
        ext: '',
      })
      return;
    }
    this.getFileHistoryList()
  }

  // 点击上传文件
  @action.bound
  clickUpload() {
    //  点击上传文件 事件上报
    report({
      eventId: 'E0503',
      pageId: 'P05',
      ext: '',
    })
  }

  // 点击删除
  @action.bound
  getDeleteId(id: number) {
    // 点击删除  事件上报
    report({
      eventId: 'E0516',
      pageId: 'P05',
      ext: '',
    })

    const _this = this
    Modal.confirm({
      title: '提示',
      content: '确定要删除该游戏吗？',
      okText: '确认',
      cancelText: '取消',
      onOk () {
        console.log('删除')
        const params = {
          gameId: id
        }
        return new Promise(async (resolve, reject) => {
          let [error] = await deleteGame(params)
          if(error){
            message.error('删除失败')
            // 删除已上传文件失败  事件上报
            report({
              eventId: 'E0512',
              pageId: 'P05',
              ext: '',
            })

            return resolve();
          }
          message.info('删除成功')
          _this.getFileList();
          return resolve()
        })
      }
    });
  }
}

